import { padZeros } from './time.js'

export function prettyDate (date) {
  if (date == null) return ''
  const d = new Date(date)
  const startDate = new Date()
  return prettyDateFromDates(startDate, d)
}

// get the prettyDate from a time delta
export function prettyDateFromDates (startDate, endDate) {
  const msPerSeconds = 1000
  const msPerMinute = msPerSeconds * 60
  const msPerHour = msPerMinute * 60
  const msPerDay = msPerHour * 24
  const msPerWeek = msPerDay * 7

  const timeDelta = startDate - endDate

  if (timeDelta < 0) {
    return '0 seconds ago'
  } else if (timeDelta < msPerMinute) {
    return `${Math.round(timeDelta / msPerSeconds)} seconds ago`
  } else if (timeDelta < msPerHour) {
    return `${Math.round(timeDelta / msPerMinute)} minutes ago`
  } else if (timeDelta < msPerDay) {
    const hours = Math.round(timeDelta / msPerHour)
    if (hours === 1) {
      return `${hours} hour ago`
    } else {
      return `${hours} hours ago`
    }
  } else if (timeDelta < msPerWeek) {
    return `${Math.round(timeDelta / msPerDay)} days ago`
  } else {
    const year = endDate.getFullYear()
    const month = endDate.getMonth() + 1
    const day = endDate.getDate()
    return `on ${month}/${day}/${year}`
  }
}

export function prettyTimeStamp (start, end) {
  return `${prettyCommentTime(start)} - ${prettyCommentTime(end)}`
}

export function prettyCommentTime (sec = 0) {
  const seconds = Math.floor(sec % 60)
  const minutes = Math.floor((sec / 60) % 60)
  const hours = Math.floor((sec / (60 * 60)) % 24)
  const hoursStr = hours !== 0
    ? `${hours}:`
    : ''
  return hoursStr + `${padZeros(minutes.toString())}:${padZeros(seconds.toString())}`
}

export function round (val) {
  return Math.round(val)
}

export const formatDate = d => {
  // d/mm/yyyy h:mm k
  const day = d.getDate()
  const month = d.getMonth() + 1
  const year = d.getFullYear()
  const hour = d.getHours() > 12 ? d.getHours() - 12 : d.getHours()
  const minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()

  const ending = d.getHours() >= 12 ? 'PM' : 'AM'

  return month + '/' + day + '/' + year + ' ' + hour + ':' + minutes + ' ' + ending
}

export function formatTextDate (date) {
  var mNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']

  const d = new Date(date)
  var sDay = d.getDate()
  // var s_date = d.getDate();
  var sMonth = d.getMonth()
  var sYear = d.getFullYear()

  return mNames[sMonth] + ' ' + sDay + ', ' + sYear
}



// WEBPACK FOOTER //
// ./src/filters.js